export const environment = {
    env: process.env.REACT_APP_ENV,
    apiBaseURLClients: process.env.REACT_APP_API_BASE_URL_CLIENTS,
    systemId: process.env.REACT_APP_SYSTEM_ID,
    disableAuth: process.env.REACT_APP_DISABLE_AUTH === 'true',
};